import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["aria-label"];
const _hoisted_2 = { class: "interactive-help-card__header" };
const _hoisted_3 = { class: "interactive-help-card__heading" };
const _hoisted_4 = {
    key: 0,
    class: "interactive-help-card__guide-title"
};
const _hoisted_5 = {
    key: 1,
    class: "interactive-help-card__progress-row"
};
const _hoisted_6 = { class: "interactive-help-card__progress" };
const _hoisted_7 = { class: "interactive-help-card__title" };
const _hoisted_8 = {
    key: 1,
    class: "interactive-help-card__hint"
};
const _hoisted_9 = {
    key: 2,
    class: "interactive-help-card__footer"
};
const _hoisted_10 = {
    key: 0,
    class: "interactive-help-card__progress"
};
const _hoisted_11 = {
    key: 1,
    class: "interactive-help-card__hint"
};
const _hoisted_12 = {
    key: 2,
    class: "interactive-help-card__actions"
};
import { computed, nextTick, onBeforeUnmount, onMounted, ref, watch, } from "vue";
import { useRoute } from "vue-router";
import { storeToRefs } from "pinia";
import { useGuideEngine } from "@/composables/useGuideEngine";
import { getHelpTarget } from "@/help/getHelpTarget";
import * as driverRenderer from "@/help/renderers/driverRenderer";
import { waitForHelpTarget } from "@/help/waitForHelpTarget";
import { dismissScreenHelp, markGuidePreference, } from "@/help/persistence";
import { useInteractiveHelpStore } from "@/store/interactiveHelpStore";
const MOBILE_BREAKPOINT = 768;
const CARD_MARGIN = 16;
const CARD_GAP = 12;
const TARGET_WAIT_TIMEOUT_MS = 8000;
const HELP_ACTIVE_ATTR = "data-help-active";
/** Ancho máx. del modal WizardFondo (debe coincidir con su CSS). */
const FUNDS_WIZARD_MAX_WIDTH = 600;
const FUNDS_HELP_CARD_WIDTH = 300;
/** Ancho máx. de `.ventas-inner` (GestionVentas, Admin, editor). */
const VENTAS_INNER_MAX_WIDTH = 640;
/** Ancho máx. de `.validar-pagos-inner`. */
const VALIDAR_PAGOS_INNER_MAX_WIDTH = 800;
const BODY_FUNDS_MOBILE_BAR_CLASS = "mc-funds-help-mobile-bar";
const BODY_TOUR_MOBILE_TOP_CLASS = "mc-tour-help-mobile-top";
const BODY_TOUR_MOBILE_BOTTOM_CLASS = "mc-tour-help-mobile-bottom";
export default /*@__PURE__*/ _defineComponent({
    __name: 'InteractiveHelpHost',
    setup(__props) {
        const isFabSpotlightHelp = (helpId) => helpId === "funds-add-fab" ||
            helpId === "expenses-view-fab" ||
            helpId === "incomes-view-fab";
        const isSalesAdminHelp = (helpId) => Boolean(helpId?.startsWith("sales-admin-") || helpId?.startsWith("donations-admin-"));
        const isSalesBuyHelp = (helpId) => Boolean(helpId?.startsWith("sales-buy-"));
        const isDonationsBuyHelp = (helpId) => Boolean(helpId?.startsWith("donations-buy-"));
        const isPaymentsValidateHelp = (helpId) => Boolean(helpId?.startsWith("payments-validate-"));
        /** Admin o compra apoderado: card a la derecha en desktop, mini-barra en móvil. */
        const isSalesColumnHelp = (helpId) => isSalesAdminHelp(helpId) ||
            isSalesBuyHelp(helpId) ||
            isDonationsBuyHelp(helpId) ||
            isPaymentsValidateHelp(helpId);
        const rectsOverlap = (a, b, gap = CARD_GAP) => a.left < b.right + gap &&
            a.right > b.left - gap &&
            a.top < b.bottom + gap &&
            a.bottom > b.top - gap;
        /**
         * Targets del flujo de fondos (FAB + modal), editor y admin de ventas:
         * sin overlay de driver.js para no bloquear clics; se usa anillo/brillo local.
         */
        const usesLocalHighlight = (helpId) => Boolean(helpId?.startsWith("funds-wizard-") ||
            helpId?.startsWith("sales-editor-") ||
            helpId?.startsWith("donations-editor-") ||
            helpId?.startsWith("sales-admin-") ||
            helpId?.startsWith("donations-admin-") ||
            helpId?.startsWith("sales-buy-") ||
            helpId?.startsWith("donations-buy-") ||
            helpId?.startsWith("sales-manage-") ||
            helpId?.startsWith("donations-manage-") ||
            helpId?.startsWith("payments-validate-") ||
            helpId?.startsWith("income-register-") ||
            helpId?.startsWith("invite-link-") ||
            helpId?.startsWith("expenses-view-") ||
            helpId?.startsWith("incomes-view-") ||
            helpId === "payments-register" ||
            helpId?.startsWith("payments-register-") ||
            helpId === "payments-upload-receipt");
        const isDockedHelp = (helpId) => Boolean(helpId?.startsWith("funds-wizard-") ||
            helpId?.startsWith("sales-editor-") ||
            helpId?.startsWith("donations-editor-"));
        const usesMobileTopBar = (helpId) => isDockedHelp(helpId) ||
            (isSalesColumnHelp(helpId) && !isPaymentsValidateHelp(helpId));
        const isTourMobileDockTarget = (helpId) => Boolean(helpId?.startsWith("funds-") ||
            helpId?.startsWith("sales-") ||
            helpId?.startsWith("donations-") ||
            helpId?.startsWith("payments-validate-") ||
            helpId?.startsWith("income-register-") ||
            helpId?.startsWith("invite-link-") ||
            helpId?.startsWith("expenses-view-") ||
            helpId?.startsWith("incomes-view-") ||
            helpId === "payments-register" ||
            helpId?.startsWith("payments-register-") ||
            helpId === "payments-upload-receipt");
        /**
         * Card arriba para ver/tocar lo que está abajo (FAB, Continuar, guardar, pago, confirmar).
         * El resto va abajo para no tapar títulos, pestañas ni el botón de crear.
         */
        const TOUR_MOBILE_TOP_TARGETS = new Set([
            "funds-add-fab",
            "funds-wizard-continue",
            "funds-wizard-create",
            "sales-editor-save",
            "donations-editor-save",
            "sales-buy-payment",
            "sales-buy-confirm",
            "donations-buy-confirm",
            "payments-validate-actions",
            "income-register-receipt",
            "income-register-submit",
            "income-register-next",
            "invite-link-generate",
            "invite-link-copy",
            "expenses-view-first-card",
            "expenses-view-fab",
            "incomes-view-first-card",
            "incomes-view-fab",
            "payments-register-continue-cuotas",
            "payments-register-continue-cc",
            "payments-register-submit-cuotas",
            "payments-register-submit-cc",
            "payments-register-amount-cuotas",
            "payments-register-amount-cc",
            "payments-register-allocation-cuotas",
            "payments-register-allocation-cc",
        ]);
        const route = useRoute();
        const helpStore = useInteractiveHelpStore();
        const { activeGuide, activeStep, isActive, status, context } = storeToRefs(helpStore);
        useGuideEngine();
        const isMobile = ref(false);
        const cardStyle = ref({});
        const helpCardEl = ref(null);
        const helpTextEl = ref(null);
        const textExpanded = ref(false);
        const textOverflows = ref(false);
        const isWaiting = ref(false);
        const waitingMessage = ref("");
        let renderGeneration = 0;
        let waitAbortController = null;
        const isVisible = computed(() => isActive.value && Boolean(activeStep.value));
        const applicableSteps = computed(() => {
            if (!activeGuide.value)
                return [];
            return activeGuide.value.steps.filter((step) => !step.when || step.when(context.value));
        });
        /** Móvil + tour docked (fondos wizard / editor ventas / admin ventas): mini-barra superior. */
        const useFundsMobileTopBar = computed(() => isMobile.value &&
            isActive.value &&
            usesMobileTopBar(activeStep.value?.target) &&
            !isTourMobileDockTarget(activeStep.value?.target));
        /** Móvil: card anclada arriba o abajo, color de tutorial, texto con «Leer más». */
        const useTourMobileDock = computed(() => isMobile.value &&
            isActive.value &&
            isTourMobileDockTarget(activeStep.value?.target));
        const tourMobileEdge = computed(() => {
            const helpId = activeStep.value?.target;
            if (!helpId)
                return "bottom";
            if (helpId.startsWith("funds-wizard-"))
                return "top";
            if (helpId === "sales-editor-title" ||
                helpId === "donations-editor-title") {
                return "bottom";
            }
            if (helpId?.startsWith("income-register-")) {
                if (helpId === "income-register-receipt" ||
                    helpId === "income-register-submit" ||
                    helpId === "income-register-next") {
                    return "top";
                }
                return "bottom";
            }
            if (helpId?.startsWith("invite-link-")) {
                if (helpId === "invite-link-generate" || helpId === "invite-link-copy") {
                    return "top";
                }
                return "bottom";
            }
            if (helpId?.startsWith("expenses-view-") || helpId?.startsWith("incomes-view-")) {
                if (helpId.endsWith("-first-card") ||
                    helpId.endsWith("-fab") ||
                    helpId.endsWith("-empty-action")) {
                    return "top";
                }
                return "bottom";
            }
            if (helpId === "payments-upload-receipt" ||
                helpId?.startsWith("payments-register-")) {
                if (helpId === "payments-register-continue-cuotas" ||
                    helpId === "payments-register-continue-cc" ||
                    helpId === "payments-register-submit-cuotas" ||
                    helpId === "payments-register-submit-cc" ||
                    helpId === "payments-register-amount-cuotas" ||
                    helpId === "payments-register-amount-cc" ||
                    helpId === "payments-register-allocation-cuotas" ||
                    helpId === "payments-register-allocation-cc") {
                    return "top";
                }
                return "bottom";
            }
            if (helpId.startsWith("sales-editor-") ||
                helpId.startsWith("donations-editor-")) {
                return "top";
            }
            if (TOUR_MOBILE_TOP_TARGETS.has(helpId))
                return "top";
            return "bottom";
        });
        const useCompactMobileChrome = computed(() => useFundsMobileTopBar.value || useTourMobileDock.value);
        const isTourColoredStep = computed(() => isTourMobileDockTarget(activeStep.value?.target));
        const showReadMore = computed(() => useTourMobileDock.value && (textOverflows.value || textExpanded.value));
        const useSheetPresentation = computed(() => {
            if (useFundsMobileTopBar.value || useTourMobileDock.value) {
                return false;
            }
            const presentation = activeStep.value?.presentation ?? "auto";
            if (presentation === "sheet")
                return true;
            if (presentation === "popover")
                return false;
            return isMobile.value;
        });
        const expectsUserAction = computed(() => Boolean(activeStep.value?.advanceOn?.event) && !isWaiting.value);
        const showManualAdvance = computed(() => {
            if (!activeStep.value)
                return false;
            if (activeStep.value.advanceOn?.event)
                return false;
            return true;
        });
        const showFooterPrimary = computed(() => showManualAdvance.value);
        const hasMultilineText = computed(() => Boolean(activeStep.value?.text?.includes("\n")));
        const isRouteValidForGuide = (routeName) => {
            if (!activeGuide.value || !activeStep.value || !routeName)
                return false;
            const normalizedRoute = String(routeName);
            return activeGuide.value.steps.some((step) => step.routeName === normalizedRoute &&
                (!step.when || step.when(context.value)));
        };
        const progressLabel = computed(() => {
            if (!activeStep.value || applicableSteps.value.length <= 1)
                return "";
            const index = applicableSteps.value.findIndex((step) => step.id === activeStep.value?.id) + 1;
            if (index <= 0)
                return "";
            // Fondos: el total depende del tipo elegido; no mostrar "de N" hasta saberlo.
            const fundsGuidePendingMode = activeGuide.value?.id === "funds.paradigm-intro" &&
                !context.value.fundMode;
            if (fundsGuidePendingMode) {
                return `Paso ${index}`;
            }
            return `Paso ${index} de ${applicableSteps.value.length}`;
        });
        const showHelpCardFooter = computed(() => {
            if (useTourMobileDock.value) {
                return showFooterPrimary.value;
            }
            return Boolean((progressLabel.value && !useCompactMobileChrome.value) ||
                expectsUserAction.value ||
                showFooterPrimary.value);
        });
        const primaryActionLabel = computed(() => {
            if (!activeStep.value)
                return "Cerrar";
            const index = applicableSteps.value.findIndex((step) => step.id === activeStep.value?.id);
            const isLast = index === applicableSteps.value.length - 1;
            return isLast ? "Listo" : "Siguiente";
        });
        const abortPendingWait = () => {
            waitAbortController?.abort();
            waitAbortController = null;
        };
        const clearWaitingState = (generation) => {
            if (generation !== renderGeneration)
                return;
            isWaiting.value = false;
            waitingMessage.value = "";
        };
        const shouldPersistGuideDismissal = () => activeGuide.value?.persistDismissal !== false;
        const forceDismiss = () => {
            if (activeGuide.value && shouldPersistGuideDismissal()) {
                markGuidePreference(activeGuide.value.id, activeGuide.value.version, "skipped");
            }
            const routeName = typeof route.name === "string" ? route.name : "";
            if (routeName && shouldPersistGuideDismissal()) {
                dismissScreenHelp(routeName);
            }
            renderGeneration += 1;
            abortPendingWait();
            isWaiting.value = false;
            waitingMessage.value = "";
            clearLocalHighlights();
            driverRenderer.destroy();
            helpStore.cancelGuide();
            helpStore.reset();
        };
        const persistGuideCompletion = (status = "completed") => {
            if (activeGuide.value && shouldPersistGuideDismissal()) {
                markGuidePreference(activeGuide.value.id, activeGuide.value.version, status);
            }
            const routeName = typeof route.name === "string" ? route.name : "";
            if (routeName && shouldPersistGuideDismissal()) {
                dismissScreenHelp(routeName);
            }
        };
        const updateViewportMode = () => {
            isMobile.value = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`).matches;
        };
        const positionCard = () => {
            if (!activeStep.value?.target ||
                useSheetPresentation.value ||
                useTourMobileDock.value) {
                cardStyle.value = {};
                return;
            }
            const target = getHelpTarget(activeStep.value.target);
            if (!target) {
                cardStyle.value = {};
                return;
            }
            const helpId = activeStep.value.target;
            const viewportWidth = window.innerWidth;
            const viewportHeight = window.innerHeight;
            const isDesktop = viewportWidth > MOBILE_BREAKPOINT;
            // FAB crear fondo: card arriba para no tapar el + con overlay.
            if (isFabSpotlightHelp(helpId)) {
                const cardWidth = Math.min(340, viewportWidth - CARD_MARGIN * 2);
                if (!isDesktop) {
                    cardStyle.value = {
                        top: `${CARD_MARGIN + 8}px`,
                        left: `${CARD_MARGIN}px`,
                        width: `${cardWidth}px`,
                    };
                    return;
                }
                cardStyle.value = {
                    top: `${CARD_MARGIN + 12}px`,
                    left: `${CARD_MARGIN}px`,
                    width: `${cardWidth}px`,
                };
                return;
            }
            // Ventas admin/compra (desktop): card a la derecha, fuera de la columna de 640px.
            if (isSalesColumnHelp(helpId) && isDesktop) {
                const cardWidth = Math.min(FUNDS_HELP_CARD_WIDTH, viewportWidth - CARD_MARGIN * 2);
                const estimatedCardHeight = 260;
                const rect = target.getBoundingClientRect();
                const columnWidth = Math.min(isPaymentsValidateHelp(helpId)
                    ? VALIDAR_PAGOS_INNER_MAX_WIDTH
                    : VENTAS_INNER_MAX_WIDTH, viewportWidth - CARD_MARGIN * 2);
                const contentRight = viewportWidth / 2 + columnWidth / 2;
                let left = Math.max(contentRight + CARD_GAP, viewportWidth - cardWidth - CARD_MARGIN);
                if (left + cardWidth > viewportWidth - CARD_MARGIN) {
                    left = viewportWidth - cardWidth - CARD_MARGIN;
                }
                let top = Math.max(CARD_MARGIN, Math.min(rect.top, viewportHeight - estimatedCardHeight - CARD_MARGIN));
                const cardRect = {
                    top,
                    left,
                    right: left + cardWidth,
                    bottom: top + estimatedCardHeight,
                };
                const targetRect = {
                    top: rect.top,
                    left: rect.left,
                    right: rect.right,
                    bottom: rect.bottom,
                };
                if (rectsOverlap(cardRect, targetRect)) {
                    left = viewportWidth - cardWidth - CARD_MARGIN;
                    top = Math.max(CARD_MARGIN, Math.min(rect.top, viewportHeight - estimatedCardHeight - CARD_MARGIN));
                    const retriedCard = {
                        top,
                        left,
                        right: left + cardWidth,
                        bottom: top + estimatedCardHeight,
                    };
                    if (rectsOverlap(retriedCard, targetRect)) {
                        top = Math.max(CARD_MARGIN, rect.top - estimatedCardHeight - CARD_GAP);
                        if (top + estimatedCardHeight > viewportHeight - CARD_MARGIN) {
                            top = Math.max(CARD_MARGIN, Math.round((viewportHeight - estimatedCardHeight) / 2));
                        }
                    }
                }
                cardStyle.value = {
                    top: `${top}px`,
                    left: `${left}px`,
                    width: `${cardWidth}px`,
                };
                return;
            }
            // Paso docked (FAB/modal fondos o editor ventas).
            if (isDockedHelp(helpId)) {
                // Móvil: mini-barra superior a ancho completo (CSS fija posición).
                if (!isDesktop) {
                    cardStyle.value = {};
                    return;
                }
                const cardWidth = Math.min(FUNDS_HELP_CARD_WIDTH, viewportWidth - CARD_MARGIN * 2);
                const estimatedCardHeight = 260;
                let top;
                let left;
                const modalRight = viewportWidth / 2 + FUNDS_WIZARD_MAX_WIDTH / 2;
                const idealLeft = modalRight + 20;
                const fitsBesideModal = helpId?.startsWith("funds-") &&
                    idealLeft + cardWidth <= viewportWidth - CARD_MARGIN;
                if (fitsBesideModal) {
                    left = idealLeft;
                    if (helpId === "funds-add-fab") {
                        top = CARD_MARGIN + 12;
                    }
                    else {
                        top = Math.max(CARD_MARGIN, Math.round((viewportHeight - estimatedCardHeight) / 2));
                    }
                }
                else {
                    left = viewportWidth - cardWidth - CARD_MARGIN;
                    top = CARD_MARGIN + 8;
                }
                const rect = target.getBoundingClientRect();
                const cardBottom = top + estimatedCardHeight;
                const cardRight = left + cardWidth;
                const overlapsTarget = left < rect.right + 12 &&
                    cardRight > rect.left - 12 &&
                    top < rect.bottom + 12 &&
                    cardBottom > rect.top - 12;
                if (overlapsTarget) {
                    if (rect.top > estimatedCardHeight + CARD_MARGIN + 40) {
                        top = Math.max(CARD_MARGIN, rect.top - estimatedCardHeight - 40);
                    }
                    else {
                        top = CARD_MARGIN;
                        left = Math.max(CARD_MARGIN, viewportWidth - cardWidth - CARD_MARGIN);
                    }
                }
                cardStyle.value = {
                    top: `${top}px`,
                    left: `${left}px`,
                    width: `${cardWidth}px`,
                };
                return;
            }
            const rect = target.getBoundingClientRect();
            const cardWidth = Math.min(360, viewportWidth - CARD_MARGIN * 2);
            const estimatedCardHeight = 240;
            const targetNearBottom = rect.bottom > viewportHeight * 0.55;
            let top;
            if (targetNearBottom) {
                top = Math.max(CARD_MARGIN, rect.top - estimatedCardHeight - CARD_GAP);
            }
            else {
                top = rect.bottom + CARD_GAP;
                if (top + estimatedCardHeight > viewportHeight - CARD_MARGIN) {
                    top = Math.max(CARD_MARGIN, rect.top - estimatedCardHeight - CARD_GAP);
                }
            }
            let left = rect.left;
            if (rect.left > viewportWidth * 0.45) {
                left = rect.right - cardWidth;
            }
            if (left + cardWidth > viewportWidth - CARD_MARGIN) {
                left = viewportWidth - cardWidth - CARD_MARGIN;
            }
            left = Math.max(CARD_MARGIN, left);
            cardStyle.value = {
                top: `${top}px`,
                left: `${left}px`,
                width: `${cardWidth}px`,
            };
        };
        const clearLocalHighlights = () => {
            document
                .querySelectorAll(`[${HELP_ACTIVE_ATTR}]`)
                .forEach((node) => node.removeAttribute(HELP_ACTIVE_ATTR));
            document
                .querySelectorAll(".mc-help-fab-spotlight")
                .forEach((node) => node.classList.remove("mc-help-fab-spotlight"));
        };
        const applyLocalHighlight = (target) => {
            clearLocalHighlights();
            target.setAttribute(HELP_ACTIVE_ATTR, "true");
        };
        const applyFabSpotlight = (target) => {
            clearLocalHighlights();
            target.classList.add("mc-help-fab-spotlight");
        };
        const renderCurrentStep = async () => {
            const generation = ++renderGeneration;
            abortPendingWait();
            if (!isActive.value || !activeStep.value) {
                clearWaitingState(generation);
                clearLocalHighlights();
                driverRenderer.hide();
                return;
            }
            const step = activeStep.value;
            if (step.routeName && route.name !== step.routeName) {
                isWaiting.value = true;
                waitingMessage.value = "Esperando la siguiente pantalla...";
                driverRenderer.hide();
                cardStyle.value = {};
                return;
            }
            if (!step.target) {
                clearWaitingState(generation);
                driverRenderer.hide();
                positionCard();
                return;
            }
            isWaiting.value = true;
            waitingMessage.value = "Preparando la orientación en pantalla...";
            driverRenderer.hide();
            await nextTick();
            if (generation !== renderGeneration)
                return;
            waitAbortController = new AbortController();
            const target = await waitForHelpTarget(step.target, {
                timeoutMs: TARGET_WAIT_TIMEOUT_MS,
                signal: waitAbortController.signal,
            });
            if (generation !== renderGeneration)
                return;
            if (!target) {
                clearWaitingState(generation);
                driverRenderer.hide();
                cardStyle.value = {};
                return;
            }
            clearWaitingState(generation);
            target.scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "nearest",
            });
            if (isFabSpotlightHelp(step.target)) {
                applyFabSpotlight(target);
                driverRenderer.showTarget({
                    element: target,
                    presentation: step.presentation,
                });
            }
            else if (usesLocalHighlight(step.target)) {
                // Sin overlay de driver: el usuario puede usar Continuar e inputs del modal.
                driverRenderer.hide();
                applyLocalHighlight(target);
            }
            else {
                clearLocalHighlights();
                driverRenderer.showTarget({
                    element: target,
                    presentation: step.presentation,
                });
            }
            await nextTick();
            if (generation !== renderGeneration)
                return;
            positionCard();
            if (!usesLocalHighlight(step.target) || isFabSpotlightHelp(step.target)) {
                driverRenderer.refresh();
            }
            await measureTourTextOverflow();
        };
        const handleClose = () => {
            forceDismiss();
        };
        const toggleTextExpanded = () => {
            textExpanded.value = !textExpanded.value;
        };
        const measureTourTextOverflow = async () => {
            await nextTick();
            if (!useTourMobileDock.value || textExpanded.value)
                return;
            const el = helpTextEl.value;
            if (!el) {
                textOverflows.value = false;
                return;
            }
            textOverflows.value = el.scrollHeight > el.clientHeight + 1;
        };
        const handlePrimaryAction = () => {
            if (!activeGuide.value || !activeStep.value) {
                forceDismiss();
                return;
            }
            const index = applicableSteps.value.findIndex((step) => step.id === activeStep.value?.id);
            const isLast = index === applicableSteps.value.length - 1;
            if (isLast) {
                renderGeneration += 1;
                abortPendingWait();
                isWaiting.value = false;
                waitingMessage.value = "";
                clearLocalHighlights();
                driverRenderer.destroy();
                persistGuideCompletion("completed");
                helpStore.completeGuide();
                helpStore.reset();
                return;
            }
            helpStore.nextStep();
        };
        const onViewportChange = () => {
            updateViewportMode();
            if (!isActive.value || !activeStep.value?.target) {
                positionCard();
                return;
            }
            const target = getHelpTarget(activeStep.value.target);
            if (!target) {
                clearWaitingState(renderGeneration);
                driverRenderer.hide();
                cardStyle.value = {};
                return;
            }
            positionCard();
            driverRenderer.refresh();
        };
        watch([activeStep, isActive, () => route.name], () => {
            void renderCurrentStep();
        });
        watch(() => route.name, (routeName) => {
            if (!isActive.value || !activeStep.value)
                return;
            if (isRouteValidForGuide(routeName))
                return;
            forceDismiss();
        });
        const syncFundsMobileBarClass = (active) => {
            document.body.classList.toggle(BODY_FUNDS_MOBILE_BAR_CLASS, active);
        };
        const syncTourMobileDockClass = () => {
            const docked = useTourMobileDock.value;
            const edge = tourMobileEdge.value;
            document.body.classList.toggle(BODY_TOUR_MOBILE_TOP_CLASS, docked && edge === "top");
            document.body.classList.toggle(BODY_TOUR_MOBILE_BOTTOM_CLASS, docked && edge === "bottom");
        };
        watch(useFundsMobileTopBar, (active) => {
            syncFundsMobileBarClass(active);
            positionCard();
        }, { immediate: true });
        watch([useTourMobileDock, tourMobileEdge], () => {
            syncTourMobileDockClass();
            positionCard();
        }, { immediate: true });
        watch(tourMobileEdge, async (nextEdge, prevEdge) => {
            if (!useTourMobileDock.value)
                return;
            if (!prevEdge || nextEdge === prevEdge)
                return;
            const el = helpCardEl.value;
            if (!el)
                return;
            const firstTop = el.getBoundingClientRect().top;
            await nextTick();
            const lastTop = el.getBoundingClientRect().top;
            const dy = firstTop - lastTop;
            if (Math.abs(dy) < 8)
                return;
            el.style.transition = "none";
            el.style.transform = `translateY(${dy}px)`;
            void el.offsetHeight;
            el.style.transition = "transform 0.48s cubic-bezier(0.22, 1, 0.36, 1)";
            el.style.transform = "translateY(0)";
            const clearMotion = (event) => {
                if (event.propertyName !== "transform")
                    return;
                el.style.transition = "";
                el.style.transform = "";
                el.removeEventListener("transitionend", clearMotion);
            };
            el.addEventListener("transitionend", clearMotion);
        });
        watch(() => activeStep.value?.id, () => {
            textExpanded.value = false;
            textOverflows.value = false;
        });
        watch(useSheetPresentation, () => {
            positionCard();
            driverRenderer.refresh();
        });
        watch(status, (nextStatus) => {
            if (nextStatus === "cancelled" ||
                nextStatus === "completed" ||
                nextStatus === "failed") {
                renderGeneration += 1;
                abortPendingWait();
                isWaiting.value = false;
                waitingMessage.value = "";
                clearLocalHighlights();
                driverRenderer.destroy();
            }
            if (nextStatus === "failed") {
                helpStore.reset();
            }
        });
        const onEscapeKey = (event) => {
            if (event.key !== "Escape" || !isActive.value)
                return;
            forceDismiss();
        };
        onMounted(() => {
            updateViewportMode();
            window.addEventListener("resize", onViewportChange);
            window.addEventListener("scroll", onViewportChange, true);
            window.addEventListener("keydown", onEscapeKey);
            if (process.env.NODE_ENV !== "production") {
                window.__interactiveHelp =
                    helpStore;
            }
            void renderCurrentStep();
        });
        onBeforeUnmount(() => {
            abortPendingWait();
            clearLocalHighlights();
            syncFundsMobileBarClass(false);
            document.body.classList.remove(BODY_TOUR_MOBILE_TOP_CLASS, BODY_TOUR_MOBILE_BOTTOM_CLASS);
            window.removeEventListener("resize", onViewportChange);
            window.removeEventListener("scroll", onViewportChange, true);
            window.removeEventListener("keydown", onEscapeKey);
            driverRenderer.destroy();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                (isVisible.value && _unref(activeStep))
                    ? (_openBlock(), _createElementBlock("article", {
                        key: 0,
                        ref_key: "helpCardEl",
                        ref: helpCardEl,
                        class: _normalizeClass(["interactive-help-card", {
                                'interactive-help-card--sheet': useSheetPresentation.value,
                                'interactive-help-card--funds-mobile-bar': useFundsMobileTopBar.value,
                                'interactive-help-card--tour': isTourColoredStep.value,
                                'interactive-help-card--tour-mobile': useTourMobileDock.value,
                                'interactive-help-card--tour-mobile-top': useTourMobileDock.value && tourMobileEdge.value === 'top',
                                'interactive-help-card--tour-mobile-bottom': useTourMobileDock.value && tourMobileEdge.value === 'bottom',
                                'interactive-help-card--tour-mobile-compact': useTourMobileDock.value && !showFooterPrimary.value,
                                'interactive-help-card--tour-text-collapsed': useTourMobileDock.value && !textExpanded.value,
                            }]),
                        style: _normalizeStyle(cardStyle.value),
                        role: "dialog",
                        "aria-modal": "true",
                        "aria-live": "polite",
                        "aria-label": _unref(activeStep).title,
                        onClick: _cache[0] || (_cache[0] = _withModifiers(() => { }, ["stop"]))
                    }, [
                        _createElementVNode("header", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                (_unref(activeGuide) && !useCompactMobileChrome.value)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_unref(activeGuide).title), 1))
                                    : _createCommentVNode("", true),
                                (useCompactMobileChrome.value && progressLabel.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                        _createElementVNode("span", _hoisted_6, _toDisplayString(progressLabel.value), 1)
                                    ]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("h2", _hoisted_7, _toDisplayString(_unref(activeStep).title), 1)
                            ]),
                            _createElementVNode("button", {
                                type: "button",
                                class: "interactive-help-card__close",
                                "aria-label": "Cerrar guía",
                                onClick: handleClose
                            }, _cache[1] || (_cache[1] = [
                                _createElementVNode("i", {
                                    class: "bi bi-x-lg",
                                    "aria-hidden": "true"
                                }, null, -1)
                            ]))
                        ]),
                        _createElementVNode("p", {
                            ref_key: "helpTextEl",
                            ref: helpTextEl,
                            class: _normalizeClass(["interactive-help-card__text", { 'interactive-help-card__text--multiline': hasMultilineText.value }])
                        }, _toDisplayString(waitingMessage.value || _unref(activeStep).text), 3),
                        (showReadMore.value)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: "interactive-help-card__read-more",
                                onClick: _withModifiers(toggleTextExpanded, ["stop"])
                            }, [
                                _createElementVNode("i", {
                                    class: _normalizeClass(["bi", textExpanded.value ? 'bi-chevron-up' : 'bi-chevron-down']),
                                    "aria-hidden": "true"
                                }, null, 2),
                                _createTextVNode(" " + _toDisplayString(textExpanded.value ? "Ocultar" : "Leer más"), 1)
                            ]))
                            : _createCommentVNode("", true),
                        (useTourMobileDock.value && expectsUserAction.value)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_8, " Toca lo resaltado "))
                            : _createCommentVNode("", true),
                        (showHelpCardFooter.value)
                            ? (_openBlock(), _createElementBlock("footer", _hoisted_9, [
                                (progressLabel.value && !useCompactMobileChrome.value)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(progressLabel.value), 1))
                                    : _createCommentVNode("", true),
                                (expectsUserAction.value && !useTourMobileDock.value)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(useCompactMobileChrome.value
                                        ? "Toca lo resaltado"
                                        : "Toca el botón resaltado en pantalla"), 1))
                                    : _createCommentVNode("", true),
                                (showFooterPrimary.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: "interactive-help-card__primary",
                                            onClick: _withModifiers(handlePrimaryAction, ["stop"])
                                        }, _toDisplayString(primaryActionLabel.value), 1)
                                    ]))
                                    : _createCommentVNode("", true)
                            ]))
                            : _createCommentVNode("", true)
                    ], 14, _hoisted_1))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
